import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export default function NewSessionButton({ onClick }) {
  const { t } = useTranslation();

  return (
    <Button
      type="primary"
      shape="round"
      size="large"
      data-testid='new-session-button'
      style={{ minWidth: '200px' }}
      onClick={onClick}
    >
      {t('session_recorder.fields.start')}
    </Button>
  );
}